

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  Button as MuiButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  //   Row,

  //   Col,
  Badge,
  IconButton,
  Tooltip,
  TablePagination,
  CircularProgress,
  TableContainer,
  Paper,
  Chip,
  Box,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem

} from "@mui/material";
import { Col, Row } from "react-bootstrap";

import {
  Dashboard as DashboardIcon,
  School as SchoolIcon,
  MarkEmailRead as MarkEmailReadIcon,
  People as PeopleIcon,
  Gavel as GavelIcon,
  Edit as EditIcon,
  Save as SaveIcon,
} from "@mui/icons-material";
import { green, yellow, red, deepPurple } from "@mui/material/colors";

// My components
import HeaderCard from "../../components/common/HeaderCard";
import SecCard from "../../components/common/SecCard";
import TermsAndConditionsModal from "../../components/common/TermsAndConditionsModal";
// import { TermsAndConditionsModal } from "../../components/common/TermsAndConditionsModal";

// For the button (default export)
import TermsAndConditionsButton from "../../components/common/TermsAndConditionsModal";
import Loader from "../../components/common/Loader";
import PrivacyPolicyModal from "../../components/common/PrivacyPolicyModal";
import { toast } from "react-hot-toast";
import { SERVER_ORIGIN } from "../../utilities/constants";
import { useUserType } from "../common/UserTypeContext";
import css from "../../css/admin/home-page.module.css";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import {
  hasPrivacyAcknowledged,
  setPrivacyAcknowledged,
} from "../../utilities/privacy_ack";

const HomePage = () => {
  const { setUserTypeToInstitute } = useUserType();

  const [isLoading, setIsLoading] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

  // Data states
  const [all_students, SetAll_students] = useState(0);
  const [all_students_onboarding_pending, SetAll_students_onboarding_pending] =
    useState(0);
  const [all_students_onboarding_invited, SetAll_students_onboarding_invited] =
    useState(0);
  const [
    all_students_onboarding_onboarded,
    SetAll_students_onboarding_onboarded,
  ] = useState(0);
  const [all_students_email_sent, SetAll_students_email_sent] = useState(0);
  const [all_students_email_not_sent, SetAll_students_email_not_sent] =
    useState(0);
  const [termsStatus, setTermsStatus] = useState("");
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [isTermsAcceptedDate, setIsTermsAcceptedDate] = useState(false);
  const [termsContent, setTermsContent] = useState("");
  const [isThalir, setIsThalir] = useState(false);
  const [tabFromUrl, setTabFromUrl] = useState("institute"); // Default value
  // T&C Status and Data Freshness
  const [tcExpiryDate, setTcExpiryDate] = useState(null);
  const [tcStatus, setTcStatus] = useState(""); // active, expiring, expired
  const [lastStudentUpdate, setLastStudentUpdate] = useState(null);
  const [onboardingCompletion, setOnboardingCompletion] = useState(0);
  console.log("isThalir", isThalir);
  console.log("tabFromUrl", tabFromUrl);
  // Thalir Schools management
  const [thalirTab, setThalirTab] = useState("students"); // students | schools
  const [schoolRows, setSchoolRows] = useState([{ name: "", studentCount: "" }]);
  const [schoolList, setSchoolList] = useState([]);
  const [isSchoolModalOpen, setIsSchoolModalOpen] = useState(false);
  const [isSchoolSaving, setIsSchoolSaving] = useState(false);
  const [schoolUploadFile, setSchoolUploadFile] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10); // default 10 rows
  const [totalSchools, setTotalSchools] = useState(0);
  const [loadingSchools, setLoadingSchools] = useState(false);
  const [instituteData, setInstituteData] = useState(null);
  const [studentData, setStudentData] = useState(null);
  const [isMOUApproved, setIsMOUApproved] = useState(false);
  const [uploadHistory, setUploadHistory] = useState([]);
  const [uploadedDataStudentsCount, setUploadedDataStudentsCount] = useState(0);
  // NEW: Single MOU student count states
  const [isSingleMou, setIsSingleMou] = useState(false);
  const [studentCountInput, setStudentCountInput] = useState("");
  const [selectedFinancialYear, setSelectedFinancialYear] = useState("");
  const [isEditingStudentCount, setIsEditingStudentCount] = useState(false);
  const [financialYearOptions, setFinancialYearOptions] = useState([]);
  const [savedStudentCount, setSavedStudentCount] = useState(null);
  const [savedFinancialYear, setSavedFinancialYear] = useState(null);
  const [studentCountHistory, setStudentCountHistory] = useState([]);

  const navigate = useNavigate();
  // NEW: Generate financial year options (last 5 years and next 2 years)
  const generateFinancialYearOptions = () => {
    const options = [];
    const currentFY = getCurrentFinancialYear();
    const [startYear] = currentFY.split('-').map(Number);

    // Add last 5 years
    for (let i = 5; i > 0; i--) {
      const year = startYear - i;
      options.push(`${year}-${(year + 1).toString().slice(-2)}`);
    }

    // Add current year
    options.push(currentFY);

    // Add next 2 years
    for (let i = 1; i <= 2; i++) {
      const year = startYear + i;
      options.push(`${year}-${(year + 1).toString().slice(-2)}`);
    }

    return options;
  };

  // Function to get font styles based on hover state
  const getFontStyle = (cardType, type = "title") => {
    const isHovered = hoveredCard === cardType;

    switch (type) {
      case "title":
        return {
          fontWeight: isHovered ? 700 : 600,
          fontSize: isHovered ? "1.1rem" : "1rem",
          color: isHovered ? "#1a56db" : "#2c3e50",
          transition: "all 0.3s ease",
        };
      case "count":
        return {
          fontWeight: isHovered ? 800 : 700,
          fontSize: isHovered ? "2.5rem" : "2.25rem",
          color: isHovered ? "#1e40af" : "#2f80ed",
          transition: "all 0.3s ease",
        };
      case "description":
        return {
          fontWeight: isHovered ? 500 : 400,
          color: isHovered ? "#4b5563" : "#7f8c8d",
          transition: "all 0.3s ease",
        };
      default:
        return {};
    }
  };

  // Function to get card style with hover effect
  const getCardStyle = (cardType, index) => {
    const isHovered = hoveredCard === cardType;
    return {
      padding: "15px",
      textAlign: "left",
      borderRadius: "12px",
      boxShadow: isHovered
        ? "0 8px 20px rgba(0,0,0,0.12)"
        : "0 4px 12px rgba(0,0,0,0.08)",
      height: "100%",
      border: "none",
      backgroundColor: "white",
      transition: "all 0.3s ease",
      transform: isHovered ? "translateY(-4px)" : "none",
      cursor: "pointer",
    };
  };

  const handleTermsButtonClick = () => {
    setIsTermsModalOpen(!isTermsModalOpen);
  };

  const renderMouStatus = (params) => {
    let statusColor;
    let statusText;
    let textColor;

    switch (params.value) {
      case "invited":
        statusColor = yellow[500];
        statusText = "Invited";
        textColor = "black";
        break;
      case "pending":
        statusColor = deepPurple[500];
        statusText = "Pending";
        textColor = "white";
        break;
      case "waiting_for_approval":
        statusColor = yellow[500];
        statusText = "Waiting for approval";
        textColor = "black";
        break;
      case "accepted":
      case "completed":
        statusColor = green[500];
        statusText = "Accepted";
        textColor = "white";
        break;
      case "onboarded":
        statusColor = green[500];
        statusText = "Onboarded";
        textColor = "white";
        break;
      case "approved":
        statusColor = green[500];
        statusText = "Approved";
        textColor = "white";
        break;
      case "rejected":
        statusColor = red[500];
        statusText = "Rejected";
        textColor = "white";
        break;
      default:
        statusColor = "black";
        statusText = "Unknown";
        textColor = "white";
    }
    return (
      <Badge>
        <span
          style={{
            backgroundColor: statusColor,
            padding: ".5rem",
            color: textColor,
          }}
        >
          {statusText}
        </span>
      </Badge>
    );
  };

  // Helper function to get current financial year (April to March cycle)
  const getCurrentFinancialYear = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1; // getMonth() returns 0-11

    if (currentMonth >= 4) {
      // April to December - current financial year started in current calendar year
      return `${currentYear}-${(currentYear + 1).toString().slice(-2)}`;
    } else {
      // January to March - current financial year started in previous calendar year
      return `${currentYear - 1}-${currentYear.toString().slice(-2)}`;
    }
  };
  console.log("setUserTypeToInstitute:", sessionStorage);
  const moutType = sessionStorage.getItem('mouType');
  console.log("moutType", moutType);


  const calculateCompletion = (institute, studentData) => {
    let completion = 0;
    console.log("completion", institute);
    // 1️⃣ Terms accepted
    if (institute.termsAccepted) {
      completion += 20;
    }

    // 2️⃣ MOU approved
    if (institute.termsAcceptanceDate && institute.signDate) {
      completion += 20;
    }

    const total = studentData.all_students || 0;
    const invited = studentData.all_students_onboarding_invited || 0;
    const onboarded = studentData.all_students_onboarding_onboarded || 0;

    // 3️⃣ Students added
    if (total > 0) {
      completion += 20;
    }

    // 4️⃣ Students invited
    if (invited > 0) {
      completion += 20;
    }

    // 5️⃣ Students onboarded (percentage based)
    if (total > 0 && onboarded > 0) {
      const onboardedPercent = (onboarded / total) * 20; // max 20%
      completion += onboardedPercent;
    }

    return Math.round(completion);
  };
  useEffect(() => {
    if (instituteData && studentData) {
      const completion = calculateCompletion(instituteData, studentData);
      setOnboardingCompletion(completion);
    }
  }, [instituteData, studentData]);
  async function canVisitPage() {
    setIsLoading(true);

    try {
      const response = await fetch(
        `${SERVER_ORIGIN}/api/institute/auth/verify-token`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": sessionStorage.getItem("token"),
          },
        }
      );

      const result = await response.json();
      setInstituteData(result.userDoc);

      console.log("canVisitPage result:", result);

      if (response.status >= 400 && response.status < 600) {
        if (response.status === 401) {
          navigate("/login?userType=institute");
        }
      }
    } catch (err) {
      console.error(err.message);
    }

    setIsLoading(false);
  }

  async function counting() {
    setIsLoading(true);
    const _id = sessionStorage.getItem("_id");

    try {
      const response = await fetch(
        `${SERVER_ORIGIN}/api/institute/auth/student-counting`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": sessionStorage.getItem("token"),
          },
          body: JSON.stringify({ _id: _id }),
        }
      );

      const result = await response.json();
      console.log("counting result:", result);

      if (response.status >= 400 && response.status < 600) {
        if (response.status === 401) {
          navigate("/login?userType=institute");
        }
      } else if (response.ok && response.status === 200) {
        SetAll_students(result.data.all_students);
        SetAll_students_onboarding_pending(result.data.all_students_onboarding_pending);
        SetAll_students_onboarding_invited(result.data.all_students_onboarding_invited);
        SetAll_students_onboarding_onboarded(result.data.all_students_onboarding_onboarded);
        SetAll_students_email_sent(result.data.all_students_email_sent);
        SetAll_students_email_not_sent(result.data.all_students_email_not_sent);

        setStudentData(result.data);

        if (result.data.lastStudentUpdate) {
          setLastStudentUpdate(new Date(result.data.lastStudentUpdate));
        }
      } else {
        navigate("/login?userType=institute");
      }
    } catch (err) {
      console.error(err.message);
    }

    setIsLoading(false);
  }

  // ────────────────────────────────────────────────
  // Now the new useEffect (keep this as is, just make sure functions exist)
  // ────────────────────────────────────────────────
  useEffect(() => {
    let isMounted = true;

    const initData = async () => {
      setUserTypeToInstitute(); // ← keep if you still need it
      setIsLoading(true);

      // Privacy acknowledgement (one-time per user)
      try {
        const userType = sessionStorage.getItem("userType") || "institute";
        const userId = sessionStorage.getItem("_id");
        // Only require privacy acknowledgement for institute/school, chapter EM, and students
        const rolesRequiringAck = new Set(["institute", "em", "user"]);
        if (rolesRequiringAck.has((userType || "").toLowerCase()) && userId && !hasPrivacyAcknowledged({ userType, userId })) {
          setIsPrivacyModalOpen(true);
        }
      } catch (e) {
        // If storage is blocked, fail open (don't block access)
        console.warn("Privacy acknowledgement check failed:", e);
      }



      // Check MOU type
      const mouType = sessionStorage.getItem('mouType');
      console.log("moutType", mouType);

      // NEW: Set isSingleMou based on MOU type
      // if (mouType === "Single MOU") {
      //   setIsSingleMou(true);
      //   // Initialize financial year options
      //   setFinancialYearOptions(generateFinancialYearOptions());
      //   // Set default financial year to current
      //   setSelectedFinancialYear(getCurrentFinancialYear());
      // }
      if (mouType === "Single MOU") {
        setIsSingleMou(true);
        await fetchFinancialYears(); // Fetch from backend
        await fetchStudentCounts(); // Fetch saved counts
      }



      try {
        // 1. Get isThalir + terms status
        const termsCheckRes = await fetch(
          `${SERVER_ORIGIN}/api/institute/auth/check-terms`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "auth-token": sessionStorage.getItem("token"),
            },
            body: JSON.stringify({ _id: sessionStorage.getItem("_id") }),
          }
        );

        if (!termsCheckRes.ok) {
          if (termsCheckRes.status === 401) {
            navigate("/login?userType=institute");
          }
          throw new Error("Failed to check terms status");
        }

        const termsCheckData = await termsCheckRes.json();
        console.log("termsCheckData:", termsCheckData);
        const isThalirValue = !!termsCheckData.data?.isThalir;
        const mouApproved = !!termsCheckData.data?.isMOUapproved;

        setIsMOUApproved(mouApproved);

        if (isMounted) {
          setIsThalir(isThalirValue);
          setIsTermsAccepted(
            !!termsCheckData?.data?.termsAccepted ||
            !!termsCheckData?.data?.isMOUapproved
          );
          // setIsTermsAccepted(termsCheckData.data.termsAccepted || termsCheckData.data.isMOUapproved || false);
          setIsTermsAcceptedDate(termsCheckData.data.termsAcceptanceDate || termsCheckData.data.isSignatureReceived || null);
          // setTermsStatus(termsCheckData.data.termsStatus || termsCheckData.data.mouStatus || "pending");
          setTermsStatus(
            termsCheckData?.data?.termsStatus === "pending"
              ? termsCheckData?.data?.mouStatus === "approved"
                ? "approved"
                : "pending"
              : termsCheckData?.data?.termsStatus || "pending"
          );

          setTcExpiryDate(termsCheckData.data.termsExpiryDate || null);

          if (termsCheckData.data.termsExpiryDate) {
            const expiry = new Date(termsCheckData.data.termsExpiryDate);
            const now = new Date();
            const daysLeft = Math.ceil((expiry - now) / (1000 * 60 * 60 * 24));
            if (expiry < now) setTcStatus("expired");
            else if (daysLeft <= 30) setTcStatus("expiring");
            else setTcStatus("active");
          } else {
            setTcStatus("active");
          }
        }

        // 2. Fetch correct terms content
        const currentFinancialYear = getCurrentFinancialYear();
        const correctTab = isThalirValue ? "thalir" : "institute";
        setTabFromUrl(correctTab);
        console.log(`Fetching active terms for tab: ${correctTab}`);

        const activeTermsRes = await fetch(
          `${SERVER_ORIGIN}/api/terms/auth/active/${currentFinancialYear}/${correctTab}`,
          {
            headers: { "auth-token": sessionStorage.getItem("token") },
          }
        );

        if (activeTermsRes.ok) {
          const activeData = await activeTermsRes.json();
          if (isMounted) {
            setTermsContent(activeData.data?.content || "No terms content available.");
          }
        } else if (activeTermsRes.status === 404) {
          if (isMounted) {
            setTermsContent("No active Terms and Conditions found for your chapter.");
          }
        }

        // 3. Load remaining data
        await counting();
        await canVisitPage();

      } catch (err) {
        console.error("Initialization error:", err);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    initData();

    return () => {
      isMounted = false;
    };
  }, [navigate, setUserTypeToInstitute]);
  const fetchThalirSchools = async (pageNum = page, perPage = rowsPerPage) => {
    if (!isThalir) return;

    setLoadingSchools(true);
    try {
      const response = await fetch(
        `${SERVER_ORIGIN}/api/institute/auth/thalir-schools?page=${pageNum + 1}&limit=${perPage}`,
        {
          headers: {
            "auth-token": sessionStorage.getItem("token"),
          },
        }
      );

      const result = await response.json();

      if (response.ok) {
        setSchoolList(result.data || []);
        setTotalSchools(result.pagination?.total || result.data.length);
      } else {
        console.error("Failed to load schools:", result.message);
        toast.error("Could not load schools list");
      }
    } catch (err) {
      console.error("Fetch schools error:", err);
      toast.error("Network error while loading schools");
    } finally {
      setLoadingSchools(false);
    }
  };

  const fetchUploadHistory = async () => {
    if (!isThalir || moutType !== "Cluster MOU") return;
    try {
      const response = await fetch(`${SERVER_ORIGIN}/api/institute/auth/thalir-schools/upload-history`, {
        headers: { "auth-token": sessionStorage.getItem("token") },
      });
      const result = await response.json();
      if (response.ok && result.data) {
        setUploadHistory(result.data.uploadHistory || []);
        setUploadedDataStudentsCount(result.data.uploadedDataStudentsCount || 0);
      }
    } catch (err) {
      console.error("Fetch upload history error:", err);
    }
  };

  // Call on mount + when pagination changes
  useEffect(() => {
    if (isThalir && isTermsAccepted && moutType === "Cluster MOU") {
      fetchThalirSchools();
      fetchUploadHistory();
    }
  }, [isThalir, thalirTab]);

  // When page or rowsPerPage changes → refetch
  useEffect(() => {
    if (isThalir && isTermsAccepted && moutType === "Cluster MOU") {
      fetchThalirSchools(page, rowsPerPage);
    }
  }, [page, rowsPerPage]);

  const addSchoolRow = () => setSchoolRows((prev) => [...prev, { name: "", studentCount: "" }]);
  const removeSchoolRow = (idx) =>
    setSchoolRows((prev) => prev.filter((_, i) => i !== idx));

  const updateSchoolRow = (idx, key, value) => {
    setSchoolRows((prev) =>
      prev.map((r, i) => (i === idx ? { ...r, [key]: value } : r))
    );
  };

  const saveSchoolRows = async () => {
    const rows = schoolRows
      .map((r) => ({
        name: String(r.name || "").trim(),
        // email: String(r.email || "").trim(),
        studentCount: r.studentCount === "" ? 0 : Number(r.studentCount),
      }))
      .filter((r) => r.name || r.studentCount);

    const invalid = rows.find((r) => !r.name);
    if (invalid) {
      toast.error("School Name and Email are mandatory for each row");
      return;
    }

    setIsSchoolSaving(true);
    try {
      const response = await fetch(`${SERVER_ORIGIN}/api/institute/auth/thalir-schools/bulk`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": sessionStorage.getItem("token"),
        },
        body: JSON.stringify({ rows }),
      });
      const result = await response.json();
      if (response.ok) {
        toast.success("Schools saved");
        setIsSchoolModalOpen(false);
        setSchoolRows([{ name: "", studentCount: "" }]);
        fetchThalirSchools();
        fetchUploadHistory();
      } else {
        toast.error(result.message || "Failed to save schools");
      }
    } catch (e) {
      console.error(e);
      toast.error("Failed to save schools");
    } finally {
      setIsSchoolSaving(false);
    }
  };

  const downloadSchoolTemplate = async () => {
    try {
      const response = await fetch(`${SERVER_ORIGIN}/api/institute/auth/thalir-schools/download-template`, {
        headers: {
          "auth-token": sessionStorage.getItem("token"),
        },
      });
      if (!response.ok) {
        toast.error("Failed to download template");
        return;
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "THALIR_SCHOOLS_TEMPLATE.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error(e);
      toast.error("Failed to download template");
    }
  };

  const uploadSchoolExcel = async () => {
    if (!schoolUploadFile) {
      toast.error("Please select an Excel file first");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("document_file", schoolUploadFile);

      const response = await fetch(`${SERVER_ORIGIN}/api/institute/auth/thalir-schools/upload`, {
        method: "POST",
        headers: {
          "auth-token": sessionStorage.getItem("token"),
        },
        body: formData,
      });

      const result = await response.json();
      if (response.ok) {
        toast.success(result.message || "Uploaded successfully");
        setSchoolUploadFile(null);
        fetchThalirSchools();
        fetchUploadHistory();
      } else {
        toast.error(result.message || "Upload failed");
      }
    } catch (e) {
      console.error(e);
      toast.error("Upload failed");
    }
  };

  function handleUsersClick() {
    if (!isTermsAccepted) {
      toast.error("Please accept Terms & Conditions first");
      return;
    }
    if (!isTermsAcceptedDate) {
      toast.error("Terms & Conditions accepted. Wait for Chapter EM approval");
      return;
    }

    const tabValue = isThalir ? "thalir" : "institute";
    navigate(`/institute/students/all?tab=${tabValue}`);
  }

  function handleStudentBtnClick() {
    toast.error("Let your MOU get approved first!");
  }

  const handleShareRegistrationLink = async () => {
    try {
      const _id = sessionStorage.getItem("_id");
      const tabType = isThalir ? "thalir" : "institute";

      const registrationLink = `${window.location.origin}/user/register/${_id}?public=true&tab=${tabType}`;

      await navigator.clipboard.writeText(registrationLink);

      toast.success(
        `${tabType === "thalir" ? "Thalir" : "YUVA"} student registration link copied to clipboard!`
      );
    } catch (error) {
      // fallback
      const _id = sessionStorage.getItem("_id");
      const tabType = isThalir ? "thalir" : "institute";

      const textArea = document.createElement("textarea");
      textArea.value = `${window.location.origin}/user/register/${_id}?public=true&tab=${tabType}`;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);

      toast.success(
        `${tabType === "thalir" ? "Thalir" : "YUVA"} student registration link copied to clipboard!`
      );
    }
  };



  // NEW: Handle student count submission for Single MOU
  // In your HomePage.jsx, update the fetch functions:

  const fetchFinancialYears = async () => {
    try {
      const response = await fetch(
        `${SERVER_ORIGIN}/api/school-student-counts/auth/get-financial-years`,
        {
          headers: {
            "auth-token": sessionStorage.getItem("token"),
          },
        }
      );
      const result = await response.json();
      if (result.success) {
        setFinancialYearOptions(result.data.availableYears);
        setSelectedFinancialYear(result.data.currentFinancialYear);
      }
    } catch (err) {
      console.error("Error fetching financial years:", err);
    }
  };

  const fetchStudentCounts = async () => {
    try {
      const response = await fetch(
        `${SERVER_ORIGIN}/api/school-student-counts/auth/get-student-counts?limit=5`,
        {
          headers: {
            "auth-token": sessionStorage.getItem("token"),
          },
        }
      );
      const result = await response.json();
      if (result.success) {
        if (result.data.currentStudentCount) {
          setSavedStudentCount(result.data.currentStudentCount.count);
          setSavedFinancialYear(result.data.currentStudentCount.financialYear);
        }
        setStudentCountHistory(result.data.studentCounts);
      }
    } catch (err) {
      console.error("Error fetching student counts:", err);
    }
  };

  const handleStudentCountSubmit = async () => {
    if (!studentCountInput || studentCountInput <= 0) {
      toast.error("Please enter a valid student count");
      return;
    }

    if (!selectedFinancialYear) {
      toast.error("Please select a financial year");
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch(
        `${SERVER_ORIGIN}/api/school-student-counts/auth/update-student-count`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": sessionStorage.getItem("token"),
          },
          body: JSON.stringify({
            studentCount: parseInt(studentCountInput),
            financialYear: selectedFinancialYear,
            notes: `Updated via dashboard on ${new Date().toLocaleDateString()}`,
          }),
        }
      );

      const result = await response.json();

      if (result.success) {
        toast.success("Student count updated successfully");
        setSavedStudentCount(parseInt(studentCountInput));
        setSavedFinancialYear(selectedFinancialYear);
        SetAll_students(parseInt(studentCountInput));
        setIsEditingStudentCount(false);

        // Refresh data
        await fetchStudentCounts();
        await counting(); // Your existing counting function
      } else {
        toast.error(result.message || "Failed to update student count");
      }
    } catch (err) {
      console.error("Error updating student count:", err);
      toast.error("Network error while updating student count");
    } finally {
      setIsLoading(false);
    }
  };
  return isLoading ? (
    <Loader />
  ) : (
    <div className={css.outerDiv}>
      <PrivacyPolicyModal
        open={isPrivacyModalOpen}
        onAccept={() => {
          const userType = sessionStorage.getItem("userType") || "institute";
          const userId = sessionStorage.getItem("_id");
          if (userId) {
            setPrivacyAcknowledged({ userType, userId });
          }
          setIsPrivacyModalOpen(false);
        }}
      />
      <HeaderCard>
        {/* <h1 className="headerTitle">
          {isThalir ? "School Dashboard" : "College Dashboard"}
        </h1> */}
        <Row className="align-items-center">
          <Col>
            <h1 className="headerTitle">
              {isThalir ? "School Dashboard" : "College Dashboard"}
            </h1>
          </Col>

          <Col xs="auto">
            <Tooltip title="Copy student registration link">
              <MuiButton
                variant="contained"
                size="small"
                startIcon={<ShareOutlinedIcon />}
                onClick={handleShareRegistrationLink}
                sx={{ textTransform: "none", borderRadius: "8px" }}
              >
                Share Registration Link
              </MuiButton>
            </Tooltip>
          </Col>
        </Row>
        <hr />
        <p className="headerSubtitle">
          {isThalir
            ? "Welcome to the school dashboard – manage your School initiatives here."
            : "Manage your students, track onboarding progress, and monitor communication status."}
        </p>
      </HeaderCard>
      <h5
        style={{
          fontWeight: 600,
          marginTop: 10,
          marginBottom: 15,
          color: "#2f80ed",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <DashboardIcon style={{ fontSize: 20 }} />
        Data Overview
      </h5>

      <Row>
        <Col  md={isThalir ? 12 : 4} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("students", 0)}
            onMouseEnter={() => setHoveredCard("students")}
            onMouseLeave={() => setHoveredCard(null)}
            onClick={isTermsAccepted ? handleUsersClick : handleStudentBtnClick}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <PeopleIcon
                  fontSize="small"
                  style={{
                    fontSize: 20,
                    color: hoveredCard === "students" ? "#1e40af" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                />
                <Typography
                  variant="subtitle2"
                  style={getFontStyle("students", "title")}
                >
                  Students
                </Typography>
              </div>
              <Typography
                variant="h4"
                style={{
                  margin: "10px 0",
                  ...getFontStyle("students", "count"),
                }}
              >
                {all_students}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Total Students
              </Typography>
            </CardContent>
          </Card>
        </Col>
        {!isThalir && (<Col md={4} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("email", 1)}
            onMouseEnter={() => setHoveredCard("email")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <MarkEmailReadIcon
                  fontSize="small"
                  style={{
                    fontSize: 20,
                    color: hoveredCard === "email" ? "#1e40af" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                />
                <Typography
                  variant="subtitle2"
                  style={getFontStyle("email", "title")}
                >
                  Email Status
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  margin: "10px 0",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h4"
                    style={getFontStyle("email", "count")}
                  >
                    {all_students_email_sent}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Sent
                  </Typography>
                </div>
                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h4"
                    style={getFontStyle("email", "count")}
                  >
                    {all_students_email_not_sent}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Not Sent
                  </Typography>
                </div>
              </div>
            </CardContent>
          </Card>
        </Col>)}

        {!isThalir && (
          <Col md={4} sm={6} xs={12}>
            <Card
              className={css.serviceCountCard}
              style={getCardStyle("onboarding", 2)}
              onMouseEnter={() => setHoveredCard("onboarding")}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <CardContent>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <SchoolIcon
                    fontSize="small"
                    style={{
                      fontSize: 20,
                      color: hoveredCard === "onboarding" ? "#1e40af" : "#2f80ed",
                      transition: "all 0.3s ease",
                    }}
                  />
                  <Typography
                    variant="subtitle2"
                    style={getFontStyle("onboarding", "title")}
                  >
                    Onboarding Status
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    margin: "10px 0",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <Typography
                      variant="h4"
                      style={getFontStyle("onboarding", "count")}
                    >
                      {all_students_onboarding_onboarded}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Onboarded
                    </Typography>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <Typography
                      variant="h4"
                      style={getFontStyle("onboarding", "count")}
                    >
                      {all_students_onboarding_invited}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Invited
                    </Typography>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <Typography
                      variant="h4"
                      style={getFontStyle("onboarding", "count")}
                    >
                      {all_students_onboarding_pending}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Pending
                    </Typography>
                  </div>
                </div>
              </CardContent>
            </Card>
          </Col>
        )}
      </Row>

      {/* NEW: Single MOU Student Count Section */}
      {/* {isSingleMou && isTermsAccepted && (
        <Box sx={{ mt: 3, mb: 2 }}>
          <Card sx={{ p: 2, borderRadius: 2, bgcolor: '#f8f9ff' }}>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2, color: '#2f80ed', fontWeight: 600 }}>
                <SchoolIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                Student Count Management (Single MOU)
              </Typography>

              {savedStudentCount && savedFinancialYear ? (
                <Box sx={{ mb: 2 }}>
                  <Alert severity="success" sx={{ mb: 2 }}>
                    Current student count for financial year {savedFinancialYear}: <strong>{savedStudentCount}</strong>
                  </Alert>
                </Box>
              ) : null}

              {!isEditingStudentCount ? (
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                  <Typography variant="body1">
                    {savedStudentCount ? (
                      <>Current count: <strong>{savedStudentCount}</strong> (FY: {savedFinancialYear})</>
                    ) : (
                      "No student count set for current financial year"
                    )}
                  </Typography>
                  <MuiButton
                    variant="outlined"
                    size="small"
                    startIcon={<EditIcon />}
                    onClick={() => setIsEditingStudentCount(true)}
                  >
                    {savedStudentCount ? "Update Count" : "Set Count"}
                  </MuiButton>
                </Box>
              ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                    <TextField
                      label="Number of Students"
                      type="number"
                      value={studentCountInput}
                      onChange={(e) => setStudentCountInput(e.target.value)}
                      size="small"
                      sx={{ minWidth: 200 }}
                      InputProps={{ inputProps: { min: 1 } }}
                    />
                    <FormControl size="small" sx={{ minWidth: 200 }}>
                      <InputLabel>Financial Year</InputLabel>
                      <Select
                        value={selectedFinancialYear}
                        onChange={(e) => setSelectedFinancialYear(e.target.value)}
                        label="Financial Year"
                      >
                        {financialYearOptions.map((year) => (
                          <MenuItem key={year} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <MuiButton
                      variant="contained"
                      startIcon={<SaveIcon />}
                      onClick={handleStudentCountSubmit}
                      disabled={isLoading}
                    >
                      {isLoading ? "Saving..." : "Save"}
                    </MuiButton>
                    <MuiButton
                      variant="outlined"
                      onClick={() => {
                        setIsEditingStudentCount(false);
                        setStudentCountInput("");
                        setSelectedFinancialYear(getCurrentFinancialYear());
                      }}
                    >
                      Cancel
                    </MuiButton>
                  </Box>
                  <Typography variant="caption" color="text.secondary">
                    Note: Current financial year is {getCurrentFinancialYear()} (April to March cycle)
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        </Box>
      )} */}
      {isSingleMou && isTermsAccepted && (
        <Box sx={{ mt: 3, mb: 2 }}>
          <Card sx={{ p: 2, borderRadius: 2, bgcolor: '#f8f9ff' }}>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2, color: '#2f80ed', fontWeight: 600 }}>
                <SchoolIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                Student Count Management (Single MOU)
              </Typography>

              {savedStudentCount && savedFinancialYear ? (
                <Alert severity="success" sx={{ mb: 2 }}>
                  Current student count for financial year {savedFinancialYear}: <strong>{savedStudentCount}</strong>
                </Alert>
              ) : null}

              {!isEditingStudentCount ? (
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                  <Typography variant="body1">
                    {savedStudentCount ? (
                      <>Current count: <strong>{savedStudentCount}</strong> (FY: {savedFinancialYear})</>
                    ) : (
                      "No student count set for current financial year"
                    )}
                  </Typography>
                  <MuiButton
                    variant="outlined"
                    size="small"
                    startIcon={<EditIcon />}
                    onClick={() => setIsEditingStudentCount(true)}
                  >
                    {savedStudentCount ? "Update Count" : "Set Count"}
                  </MuiButton>
                </Box>
              ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                    <TextField
                      label="Number of Students"
                      type="number"
                      value={studentCountInput}
                      onChange={(e) => setStudentCountInput(e.target.value)}
                      size="small"
                      sx={{ minWidth: 200 }}
                      InputProps={{ inputProps: { min: 1 } }}
                    />
                    <FormControl size="small" sx={{ minWidth: 200 }}>
                      <InputLabel>Financial Year</InputLabel>
                      <Select
                        value={selectedFinancialYear}
                        onChange={(e) => setSelectedFinancialYear(e.target.value)}
                        label="Financial Year"
                      >
                        {financialYearOptions.map((year) => (
                          <MenuItem key={year} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <MuiButton
                      variant="contained"
                      startIcon={<SaveIcon />}
                      onClick={handleStudentCountSubmit}
                      disabled={isLoading}
                    >
                      {isLoading ? "Saving..." : "Save"}
                    </MuiButton>
                    <MuiButton
                      variant="outlined"
                      onClick={() => {
                        setIsEditingStudentCount(false);
                        setStudentCountInput("");
                        setSelectedFinancialYear(getCurrentFinancialYear());
                      }}
                    >
                      Cancel
                    </MuiButton>
                  </Box>
                  <Typography variant="caption" color="text.secondary">
                    Note: Current financial year is {getCurrentFinancialYear()} (April to March cycle)
                  </Typography>
                </Box>
              )}

              {/* Student Count History */}
              {studentCountHistory.length > 0 && (
                <Box sx={{ mt: 3 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                    Historical Data
                  </Typography>
                  <TableContainer component={Paper} sx={{ border: "1px solid #e0e0e0", borderRadius: 2, overflow: "hidden" }}>
                    <Table size="small" aria-label="upload history">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Financial Year</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 600 }}>Student Count</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Last Updated</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {studentCountHistory.map((record) => (
                          <TableRow key={record._id} hover>
                            <TableCell>{record.financialYear}</TableCell>
                            <TableCell align="right">{record.count}</TableCell>
                            <TableCell>
                              {new Date(record.updatedAt).toLocaleDateString('en-IN', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric'
                              })}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              )}
            </CardContent>
          </Card>
        </Box>
      )}


      {/* Quick Navigation Section */}
      <h5
        style={{
          fontWeight: 600,
          marginTop: 25,
          marginBottom: 15,
          color: "#2f80ed",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <DashboardIcon style={{ fontSize: 20 }} />
        Management
      </h5>



      <Row>
        <Col md={6} sm={12} className="mb-4">
          <Card
            style={{
              padding: "20px",
              textAlign: "left",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              height: "100%",
              border: "none",
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent
              style={{
                padding: "0",
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "12px",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <GavelIcon fontSize="small" style={{ color: "#2f80ed" }} />
                  <Typography
                    variant="subtitle1"
                    fontWeight={600}
                    style={{ color: "#2c3e50" }}
                  >
                    Terms & Conditions
                  </Typography>
                </div>
                <Tooltip title="Current terms status">
                  {renderMouStatus({ value: termsStatus })}
                </Tooltip>
              </div>
              {isMOUApproved && (
                <div
                  style={{
                    marginBottom: "16px",
                    padding: "12px 16px",
                    backgroundColor: "#e8f5e9",
                    borderLeft: "4px solid #4caf50",
                    borderRadius: "4px",
                    color: "#1b5e20",
                  }}
                >
                  <strong>MOU Approved</strong> — Your Memorandum of Understanding has been
                  approved by the Chapter EM. You can now proceed with full student management.
                </div>
              )}
              {/* T&C Status Display */}
              {isTermsAccepted && tcStatus && (
                <div style={{ marginBottom: "12px" }}>
                  <Chip
                    label={
                      tcStatus === "active"
                        ? "Active"
                        : tcStatus === "expiring"
                          ? "Expiring Soon"
                          : "Expired"
                    }
                    color={
                      tcStatus === "active"
                        ? "success"
                        : tcStatus === "expiring"
                          ? "warning"
                          : "error"
                    }
                    size="small"
                    style={{ marginRight: "8px" }}
                  />
                  {tcExpiryDate && (
                    <Typography variant="caption" color="text.secondary">
                      Expires:{" "}
                      {tcExpiryDate
                        ? new Date(tcExpiryDate).toLocaleDateString("en-GB")
                        : "N/A"}
                    </Typography>

                  )}
                </div>
              )}

              {/* Student Data Freshness */}
              {lastStudentUpdate && (
                <div style={{ marginBottom: "12px", padding: "8px", backgroundColor: "#f5f5f5", borderRadius: "4px" }}>
                  <Typography variant="caption" color="text.secondary">
                    Last Student Update: {lastStudentUpdate.toLocaleDateString()}
                  </Typography>
                </div>
              )}

              {/* Onboarding Completion */}
              <div style={{ marginBottom: "12px" }}>
                <Typography variant="body2" color="text.secondary" style={{ marginBottom: "4px" }}>
                  Onboarding Completion
                </Typography>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <div style={{ flex: 1, height: "8px", backgroundColor: "#e0e0e0", borderRadius: "4px", overflow: "hidden" }}>
                    <div
                      style={{
                        width: `${onboardingCompletion}%`,
                        height: "100%",
                        backgroundColor: onboardingCompletion >= 80 ? "#4caf50" : onboardingCompletion >= 50 ? "#ff9800" : "#f44336",
                        transition: "width 0.3s ease",
                      }}
                    />
                  </div>
                  <Typography variant="body2" fontWeight={600}>
                    {onboardingCompletion}%
                  </Typography>
                </div>
              </div>

              {/* Terms & Conditions Content */}
              <div
                style={{
                  maxHeight: "200px",
                  overflowY: "auto",
                  border: "1px solid #e0e0e0",
                  borderRadius: "4px",
                  padding: "12px",
                  marginBottom: "12px",
                  backgroundColor: "#f9f9f9",
                }}
              >
                <div dangerouslySetInnerHTML={{ __html: termsContent }} />
              </div>

              <Typography
                variant="body2"
                style={{
                  marginBottom: "12px",
                  color: "#7f8c8d",
                  fontSize: "14px",
                  lineHeight: "1.4",
                }}
              >
                {isTermsAccepted
                  ? "You have accepted the Terms and Conditions. You can now manage students."
                  : "You need to accept the Terms and Conditions to proceed with student management"}
              </Typography>

              {isTermsAcceptedDate && (
                <div
                  style={{
                    padding: "8px 12px",
                    backgroundColor: "#d4edda",
                    color: "#155724",
                    borderRadius: "4px",
                    marginBottom: "12px",
                    fontSize: "14px",
                  }}
                >
                  <strong>Terms Accepted!</strong> You can now manage students.
                </div>
              )}

              {/* Single Button for Terms */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "auto",
                }}
              >
                {isTermsAccepted ? (
                  <TermsAndConditionsButton
                    instituteId={sessionStorage.getItem("_id")}
                    text="View Terms & Conditions"
                    isAccepted={true}
                    show={isTermsModalOpen}
                    onHide={handleTermsButtonClick}
                    tabFromUrl={tabFromUrl} // Pass tab data here
                  // disabled={isMOUApproved}   // ✅ disable when MOU approved


                  />
                ) : (
                  <TermsAndConditionsButton
                    instituteId={sessionStorage.getItem("_id")}
                    text="View Terms & Conditions"
                    show={isTermsModalOpen}
                    onHide={handleTermsButtonClick}
                    // disabled={isMOUApproved}   // ✅ disable when MOU approved

                    tabFromUrl={tabFromUrl}

                  />
                )}
              </div>
            </CardContent>
          </Card>
        </Col>

        <Col md={6} sm={12} className="mb-4">
          <Card
            style={{
              padding: "20px",
              textAlign: "left",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              height: "100%",
              border: "none",
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent
              style={{
                padding: "0",
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "12px",
                }}
              >
                <PeopleIcon
                  fontSize="small"
                  style={{ color: isTermsAccepted && isTermsAcceptedDate ? "#2f80ed" : "#ccc" }}
                />
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  style={{ color: isTermsAccepted && isTermsAcceptedDate ? "#2c3e50" : "#ccc" }}
                >
                  Manage Students
                </Typography>
              </div>
              <Typography
                variant="body2"
                style={{
                  marginBottom: "20px",
                  color: isTermsAccepted && isTermsAcceptedDate ? "#7f8c8d" : "#ccc",
                  fontSize: "14px",
                  lineHeight: "1.4",
                  flex: 1,
                }}
              >
                You can manage the students on the app by clicking on below
                button
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "auto",
                }}
              >
                <button
                  style={{
                    padding: "8px 20px",
                    borderRadius: "6px",
                    border: isTermsAccepted && isTermsAcceptedDate
                      ? "1px solid #2f80ed"
                      : "1px solid #ccc",
                    backgroundColor: "transparent",
                    color: isTermsAccepted && isTermsAcceptedDate ? "#2f80ed" : "#ccc",
                    fontWeight: "500",
                    cursor: isTermsAccepted && isTermsAcceptedDate ? "pointer" : "not-allowed",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    minWidth: "120px",
                  }}
                  onMouseEnter={(e) => {
                    if (isTermsAccepted && isTermsAcceptedDate) {
                      e.target.style.backgroundColor = "#2f80ed";
                      e.target.style.color = "white";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (isTermsAccepted && isTermsAcceptedDate) {
                      e.target.style.backgroundColor = "transparent";
                      e.target.style.color = "#2f80ed";
                    }
                  }}
                  onClick={handleUsersClick}
                  disabled={!isTermsAccepted || !isTermsAcceptedDate}
                >
                  Manage Students
                </button>
              </div>
              {/* Message Logic */}
              {!isTermsAccepted ? (
                <div
                  style={{
                    marginTop: "12px",
                    textAlign: "center",
                    color: "#6c757d",
                    fontSize: "12px",
                  }}
                >
                  Please accept Terms & Conditions first
                </div>
              ) : !isTermsAcceptedDate ? (
                <div
                  style={{
                    marginTop: "12px",
                    textAlign: "center",
                    color: "#6c757d",
                    fontSize: "12px",
                  }}
                >
                  Terms & Conditions accepted. Wait for Chapter EM approval.
                </div>
              ) : null}

            </CardContent>
          </Card>
        </Col>
      </Row>
      {isThalir && isTermsAccepted && moutType === "Cluster MOU" && (
        <div style={{ marginBottom: 18 }}>
          {/* <div style={{ display: "flex", gap: 10, marginBottom: 12 }}>
            <MuiButton
              variant={thalirTab === "schools" ? "contained" : "outlined"}
              onClick={() => setThalirTab("schools")}
            >
              Schools
            </MuiButton>
            <MuiButton
              variant={thalirTab === "students" ? "contained" : "outlined"}
              onClick={() => setThalirTab("students")}
            >
              Students
            </MuiButton>
          </div> */}

          {/* Uploaded Sheets Section */}
          {uploadHistory.length > 0 && (
            <Card style={{ padding: 16, borderRadius: 12, marginBottom: 18 }}>
              <CardContent style={{ padding: 0 }}>
                <Typography variant="subtitle1" fontWeight={600} sx={{ marginBottom: 2 }}>
                  Uploaded Sheets
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 2 }}>
                  Excel sheets uploaded for Cluster MOU Thalir (schools & student counts)
                </Typography>
                <TableContainer component={Paper} sx={{ border: "1px solid #e0e0e0", borderRadius: 2, overflow: "hidden" }}>
                  <Table size="small" aria-label="upload history">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>File Name</TableCell>
                        <TableCell align="right" sx={{ fontWeight: 600 }}>Schools</TableCell>
                        <TableCell align="right" sx={{ fontWeight: 600 }}>Students (from sheet)</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Uploaded At</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {uploadHistory.map((log, idx) => (
                        <TableRow key={idx}>
                          <TableCell>{log.fileName}</TableCell>
                          <TableCell align="right">{log.schoolsCount}</TableCell>
                          <TableCell align="right">{log.totalStudentsFromSheet}</TableCell>
                          <TableCell>
                            {log.createdAt
                              ? new Date(log.createdAt).toLocaleString("en-IN", {
                                dateStyle: "medium",
                                timeStyle: "short",
                              })
                              : "-"}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Typography variant="body2" color="primary" sx={{ marginTop: 2, fontWeight: 500 }}>
                  Total students from uploaded data: <strong>{uploadedDataStudentsCount}</strong>
                </Typography>
              </CardContent>
            </Card>
          )}

          {/* {thalirTab === "schools" && ( */}
          <Card style={{ padding: 16, borderRadius: 12 }}>
            <CardContent style={{ padding: 0 }}>
              {/* Header + buttons */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, flexWrap: "wrap", gap: 12 }}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Schools List
                </Typography>
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                  <MuiButton variant="outlined" onClick={downloadSchoolTemplate}>
                    Download Template
                  </MuiButton>
                  <MuiButton
                    variant="contained"
                    onClick={() => setIsSchoolModalOpen(true)}
                  >
                    Add Schools
                  </MuiButton>
                </div>
              </div>

              {/* Upload section */}
              <div style={{ marginBottom: 16 }}>
                <input
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={(e) => setSchoolUploadFile(e.target.files?.[0] || null)}
                  style={{ display: "inline-block", marginRight: 12 }}
                />
                <MuiButton variant="outlined" onClick={uploadSchoolExcel}>
                  Upload Excel
                </MuiButton>
              </div>

              {/* Table */}
              <TableContainer component={Paper} sx={{ border: '1px solid #e0e0e0', borderRadius: 2, overflow: 'hidden' }}>
                <Table size="small" aria-label="schools table">

                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600, color: '#000000' }}>
                        School Name
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{ fontWeight: 600, color: '#000000' }}
                      >
                        Student Count
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{ fontWeight: 600, color: '#000000' }}
                      >
                        Cordinator Name
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{ fontWeight: 600, color: '#000000' }}
                      >
                        Cordinator Email
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{ fontWeight: 600, color: '#000000' }}
                      >
                        Cordinator Mobile
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loadingSchools ? (
                      <TableRow>
                        <TableCell colSpan={2} align="center" sx={{ py: 6 }}>
                          <CircularProgress />
                        </TableCell>
                      </TableRow>
                    ) : schoolList.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={2} align="center" sx={{ py: 6, color: "text.secondary" }}>
                          No schools found.
                        </TableCell>
                      </TableRow>
                    ) : (
                      schoolList.map((school) => (
                        <TableRow
                          key={school._id}
                          hover
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell component="th" scope="row">
                            {school.name}
                          </TableCell>
                          <TableCell align="right">
                            {school.studentCount ?? 0}
                          </TableCell>
                          <TableCell align="right">
                            {school.cordinatorName ?? "N/A"}
                          </TableCell>
                          <TableCell align="right">
                            {school.cordinatorEmail ?? "N/A"}
                          </TableCell>
                          <TableCell align="right">
                            {school.cordinatorNumber ?? "N/A"}
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Pagination */}
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={totalSchools}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={(_, newPage) => setPage(newPage)}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(0);
                }}
                labelRowsPerPage="Schools per page:"
                labelDisplayedRows={({ from, to, count }) =>
                  `${from}–${to} of ${count}`
                }
                sx={{
                  borderTop: "1px solid",

                  // 👇 Force ALL pagination text black
                  "& .MuiTablePagination-toolbar": {
                    color: "#000",
                  },
                  "& .MuiTablePagination-displayedRows": {
                    color: "#000 !important",
                    fontWeight: 600,
                  },

                  // "& .MuiTablePagination-displayedRows": {
                  //   color: "#000",
                  //   // fontWeight: 500,
                  // },

                  "& .MuiTablePagination-selectLabel": {
                    color: "#000",
                  },

                  "& .MuiTablePagination-select": {
                    color: "#000",
                  },

                  "& .MuiSvgIcon-root": {
                    color: "#000",
                  },
                }}
              />

            </CardContent>
          </Card>
          {/* )} */}
        </div>
      )}
      <Dialog open={isSchoolModalOpen} onClose={() => setIsSchoolModalOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Add Schools (multiple rows)</DialogTitle>
        <DialogContent dividers>
          {schoolRows.map((row, idx) => (
            <div key={idx} style={{ display: "grid", gridTemplateColumns: "2fr 2fr 1fr auto", gap: 10, marginBottom: 10 }}>
              <TextField
                label="School Name *"
                value={row.name}
                onChange={(e) => updateSchoolRow(idx, "name", e.target.value)}
                size="small"
              />
              <TextField
                label="Student Count"
                value={row.studentCount}
                onChange={(e) => updateSchoolRow(idx, "studentCount", e.target.value)}
                size="small"
              />
              <MuiButton variant="outlined" color="error" onClick={() => removeSchoolRow(idx)} disabled={schoolRows.length === 1}>
                Remove
              </MuiButton>
            </div>
          ))}
          <MuiButton variant="outlined" onClick={addSchoolRow}>
            Add Row
          </MuiButton>
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={() => setIsSchoolModalOpen(false)} disabled={isSchoolSaving}>
            Cancel
          </MuiButton>
          <MuiButton variant="contained" onClick={saveSchoolRows} disabled={isSchoolSaving}>
            {isSchoolSaving ? "Saving..." : "Save"}
          </MuiButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default HomePage;
